import { render, staticRenderFns } from "./WaybillSharedIndex.vue?vue&type=template&id=27b20b4d&"
import script from "./WaybillSharedIndex.vue?vue&type=script&lang=js&"
export * from "./WaybillSharedIndex.vue?vue&type=script&lang=js&"
import style0 from "./WaybillSharedIndex.vue?vue&type=style&index=0&id=27b20b4d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports